<template>

    <div id="layout-auth" class="layout">
        <v-the-alerts />
        <v-the-cookie-banner />
        <transition name="modal">
            <v-modal-cookie-preferences v-if="modal === 'cookie-preferences'" />
        </transition>
        <transition name="modal">
            <v-modal-logout v-if="modal === 'logout'" />
        </transition>
        <v-the-header />
        <div class="layout-body">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
        <v-the-footer />
    </div>

</template>

<style scoped lang="scss">

    .layout {
        background: $color-white;
        display: flex;
        flex-direction: column;
        min-height: 100%;
        .layout-body {
            align-items: center;
            display: flex;
            flex-grow: 1;
            padding: 30px 0;
            @media (max-width: map-get($grid-breakpoints, 'sm')) {
                padding: 15px 0;
            }
        }
    }

</style>

<script>

import ModalCookiePreferences from '@modals/ModalCookiePreferences';
import ModalLogout from '@modals/ModalLogout';
import moment from 'moment';
import TheAlerts from '@cmp/TheAlerts';
import TheCookieBanner from '@cmp/TheCookieBanner';
import TheFooter from '@cmp/TheFooter';
import TheHeader from '@cmp/TheHeader';

export default {

    components: {
        'v-modal-cookie-preferences': ModalCookiePreferences,
        'v-modal-logout': ModalLogout,
        'v-the-alerts': TheAlerts,
        'v-the-cookie-banner': TheCookieBanner,
        'v-the-footer': TheFooter,
        'v-the-header': TheHeader,
    },

    computed: {

        modal() {
            return this.$store.getters.modal;
        },

        user() {
            return this.$store.getters.user;
        },

        hasFunctionalConsent() {
            return this.$store.getters.hasFunctionalConsent;
        },

    },

    watch: {

        hasFunctionalConsent(val) {
            if (val) this.initHelpScout();
        },

        user(val) {
            if (val) this.initHelpScout();
        },

    },

    beforeCreate() {
        if (!localStorage.getItem('lang')) {
            this.$store.commit('setTempLang');
        }
    },

    mounted() {
        const domain = window.location.hostname.toLowerCase().replace('www.', '');
        if (domain !== process.env.VUE_APP_DOMAIN && typeof window.Beacon === 'function') {
            window.Beacon('destroy');
            window.Beacon('on', 'ready', () => window.Beacon('destroy'));
            return;
        }
        this.initHelpScout();
    },

    methods: {

        initHelpScout() {
            const domain = window.location.hostname.toLowerCase().replace('www.', '');
            if (domain !== process.env.VUE_APP_DOMAIN) return;
            if (typeof window.Beacon === 'undefined') return;

            window.Beacon('init', process.env.VUE_APP_HELPSCOUT_KEY);

            const user = this.user;
            if (!user || user.is_sub_account) return;

            window.Beacon('identify', {
                name: user.name,
                email: user.email,
                signature: user.helpscout_signature,
                user_id: String(user.id),
                plan: user.plan ? user.plan.slug : 'free',
                billing_id: user.billing_id !== null ? user.billing_id : '',
                billing_plan: user.billing_plan !== null ? user.billing_plan : '',
                billing_status: user.billing_status !== null ? user.billing_status : '',
                agency: user.features?.agency ? 'Yes' : 'No',
                signed_up_at: moment.unix(user.created_at).format('YYYY-MM-DD'),
                trial_ends_at: user.trial_ends_at ? moment.unix(user.trial_ends_at).format('YYYY-MM-DD') : '',
                subscribed_at: user.subscribed_at ? moment.unix(user.subscribed_at).format('YYYY-MM-DD') : '',
            });
        },

    },

}

</script>